import React from 'react';
import NavBar from '../components/navbar';
import { Paper, Typography, TextField, FormControlLabel, Checkbox, Button } from '@material-ui/core';
import '../styles/createexercise.css';
import FirebaseConnector from '../data/FirebaseConnector';
import { Exercise } from '../data/data';
import history from '../components/history';

const rootClass = "createexercise root"
const inputClass = "createexercise input";
const klassenContainerClass = "createexercise klassenContainer";
const submitClass = "createexercise submit";
const errorClass = "createexercise error";
const successClass = "createexercise success";

const getKlassen = (klassen) => {
    const kl = [];
    for (let e in klassen) {
        if (klassen[e]) kl.push(e);
    }
    return kl;
}

class CreateExercise extends React.Component {

    constructor(...args) {
        super(...args);
        this.state = {
            title: '',
            editingTitle: true,
            problem: '',
            solution: '',
            klassen: {},
            processing: false,
            success: false,
            error: false,
        }
        this.submitBtn = this.submitBtn.bind(this);
        this.submitBtnDisabled = this.submitBtnDisabled.bind(this);
    }

    async componentDidMount() {
        const db = new FirebaseConnector();
        const user = await db.getUserData();
        if(!user) {
            history.push('/login');
        }
        const kl = {};
        [5, 6, 7, 8, 9, 10].forEach(e => {
            kl[e] = false;
        });
        this.setState({ klassen: kl });
    }

    textHandler = name => event => {
        this.setState({ [name]: event.target.value });
    };

    render() {
        if (this.state.error) {
            setTimeout(() => history.push('/'), 5000);
            return (
                <>
                    <NavBar />
                    <div className={errorClass}>
                        <Typography variant="h4">
                            An error occured while submitting the exercise!
                        </Typography>
                        <Typography variant="h6">You will be redirected in 5 seconds.</Typography>
                    </div>
                </>
            )
        }
        if (this.state.success) {
            setTimeout(() => history.push('/'), 5000);
            return (
                <>
                    <NavBar />
                    <div className={successClass}>
                        <Typography variant="h4">
                            Successfully created the exercise!
                        </Typography>
                        <Typography variant="h6">You will be redirected in 5 seconds.</Typography>
                    </div>
                </>
            )
        }
        return (
            <>
                <NavBar />
                <Paper className={rootClass}>
                    {this.state.editingTitle ? (
                        <TextField label="" value={this.state.title} onChange={this.textHandler('title')} type="text" className={inputClass} variant="outlined" autoFocus={true} onBlur={() => this.setState({ editingTitle: false })} fullWidth></TextField>
                    ) : (
                            <Typography variant="h6" onClick={() => this.setState({ editingTitle: true })}>{this.state.title.length >= 1 ? this.state.title : 'Title'}</Typography>
                        )}
                    <hr />
                    <TextField label="Problem" value={this.state.problem} onChange={this.textHandler('problem')} type="text" className={inputClass} variant="outlined" fullWidth></TextField>
                    <hr />
                    <TextField label="Solution" value={this.state.solution} onChange={this.textHandler('solution')} type="text" className={inputClass} variant="outlined" fullWidth></TextField>
                    <hr />
                    <div className={klassenContainerClass}>
                        {Object.keys(this.state.klassen).map(e => {
                            return (
                                <FormControlLabel
                                    control={<Checkbox checked={this.state.klassen[e]} onChange={() => this.setState({ klassen: { ...this.state.klassen, [e]: !this.state.klassen[e] } })} name={e + ''} />}
                                    label={e + '. Klasse'}
                                    key={e}
                                />
                            );
                        })}
                    </div>
                    <hr />
                    <Button color="primary" className={submitClass} variant="contained" onClick={this.submitBtn} disabled={this.submitBtnDisabled()} fullWidth>Aufgabe einreichen</Button>
                </Paper>
            </>
        );
    }

    async submitBtn() {
        await this.setState({
            processing: true,
        });
        const db = new FirebaseConnector();
        const user = await db.getUserData();
        const kl = getKlassen(this.state.klassen);
        const exercise = new Exercise('id', this.state.title, user.id, this.state.problem, this.state.solution, {}, new Date().getTime(), kl, false);
        const success = await db.createExercise(exercise);
        if (success) {
            this.setState({ success: true, error: false });
        } else {
            this.setState({ error: true, success: false });
        }
    }

    submitBtnDisabled() {
        const s = this.state;
        if (s.processing) {
            return true;
        }
        return !(s.title.length > 1 && s.problem.length > 1 && s.solution.length > 1 && getKlassen(s.klassen).length >= 1);
    }

}

export default CreateExercise;